<div class="container-corp">
    <div class="box" [ngClass]="{ 'no-item': corpLst.length == 0 }">
        <div class="content">
            <div *ngIf="corpLst.length> 0" class="office-list">
                <ng-container *ngFor="let corp of corpLst; let i = index">
                <caremoni-button [scaledpad]="1" [dpad]="DpadZoneType.TV_CORP_SELECT" [xdpad]="0" [ydpad]="i"
                    [buttonType]="buttonType.TV_OFFICE_SELECT" [buttonText]="corp.name" (btnClick)="onPickCorp(corp)">
                </caremoni-button>
                </ng-container>
            </div>
        </div>
    </div>
</div>